import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAllowedAction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#F0746B"
      d="M3.299 1.094C3.713.437 4.446 0 5.243 0h5.514c.797 0 1.53.438 1.944 1.094l2.964 4.75a2.22 2.22 0 0 1 0 2.343l-2.964 4.75A2.3 2.3 0 0 1 10.757 14H5.243c-.797 0-1.53-.406-1.944-1.062L.335 8.188a2.22 2.22 0 0 1 0-2.344zm3.92 2.656v3.5c0 .438.35.75.765.75.446 0 .797-.312.797-.75v-3.5c0-.406-.35-.75-.797-.75a.77.77 0 0 0-.765.75M7.984 9c-.542 0-1.02.469-1.02 1 0 .563.478 1 1.02 1 .574 0 1.052-.437 1.052-1 0-.531-.478-1-1.052-1"
    />
  </svg>
);
export default SvgAllowedAction;
